import http from "../../http";
import { API_URLs } from "../../CONSTANTS";

const pallete_apis = API_URLs.pallete;

export const apiCall_getPalletes = async (data) => {
  let qs = "";
  if (data?.materialId) {
    qs = "?materialId=" + data?.materialId;
  }
  return http.get(pallete_apis.getPalletes + qs);
};

export const apiCall_getColors = async () => {
  return http.get(pallete_apis.getColors);
};

export const apiCall_getPalleteMaterials = async () => {
  return http.get(pallete_apis.getMaterials);
};
export const apiCall_deletePallete = async (id) => {
  return http.delete(pallete_apis.deletePallete + "?id=" + id);
};

export const apiCall_editPallete = async ({ id, price }) => {
  return http.post(pallete_apis.editPallete + "?id=" + id + "&price=" + price);
};

export const apiCall_createPallete = async ({
  name,
  code,
  materialId,
  colorId,
  pricePerMeter,
  image,
}) => {
  const frm = new FormData();
  frm.append("code", code);
  frm.append("materialId", materialId);
  frm.append("colorId", colorId);
  frm.append("pricePerMeter", pricePerMeter);
  frm.append("image", image);

  return http.post(pallete_apis.createPallete, frm);
};
